// Rendering group ID of the scene objects (spheres) must be higher than the viewer's PhotoDome
const RenderingGroups = {
    DomeRenderingGroupId: 0,
    ObjectsRenderingGroupId: 1
}

var ViewerConstants = {
    RenderingGroups: RenderingGroups,
    DomeRadius: 500
};

export default ViewerConstants;